import { render, staticRenderFns } from "./ImagePreview.vue?vue&type=template&id=024f5b80&scoped=true"
import script from "./ImagePreview.vue?vue&type=script&lang=js"
export * from "./ImagePreview.vue?vue&type=script&lang=js"
import style0 from "./ImagePreview.vue?vue&type=style&index=0&id=024f5b80&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024f5b80",
  null
  
)

export default component.exports